import type { PETComposition } from 'api';

export const getTotalPet = (composition: PETComposition): number => {
  return (
    (composition.clear ?? 0) +
    (composition.light_blue ?? 0) +
    (composition.dark_blue ?? 0) +
    (composition.green ?? 0) +
    (composition.white ?? 0) +
    (composition.brown ?? 0) +
    (composition.other_colour ?? 0) +
    (composition.clear_non_food_grade ?? 0) +
    (composition.clear_pet_tray ?? 0) +
    (composition.pet_tray_contaminated_clear ?? 0) +
    (composition.full_sleeve ?? 0) +
    (composition.oil_bottle ?? 0)
  );
};
